<template>
  <div>
    <jet-responsive-nav-link
      :href="route('home')"
      :active="route().current('home')"
    >
      Dashboard
    </jet-responsive-nav-link>

    <div class="border-t border-gray-200"></div>

    <div class="block px-4 py-2 text-xs text-gray-400">
      Cadastro
    </div>
    <jet-responsive-nav-link :href="route('accesscontrol.index')">
      Controle de Acesso
    </jet-responsive-nav-link>
    <jet-responsive-nav-link :href="route('user.index')">
      Usuário
    </jet-responsive-nav-link>
    <jet-responsive-nav-link :href="route('centro-custo.index')">
      Centro de Custo
    </jet-responsive-nav-link>
  </div>
</template>

<script>
import JetResponsiveNavLink from '@/Jetstream/ResponsiveNavLink'
export default {
  components: { JetResponsiveNavLink }
}
</script>

<style>
</style>
